import cancel from '../../../favicon/cancel.svg'
import { useState } from 'react';
import { Notification, Uploader, useToaster } from 'rsuite';
import { APIRequest, ApiUrl, authHeaders } from '../../../Helpers/ApiHelper';
import hasError from '../../../Helpers/ErrorHelper';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import CustomSlider from '../../comman/CustomSlider';
import document from '../../../favicon/document.png';
import plusAdd from "../../../favicon/plus.svg"
import checkmark_blacktick from '../../../favicon/checkmark_black.svg'
import { FaFacebook } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { motion } from "framer-motion";




const DetailModal = ({ setShowSocialPlatform,showModal, setShowModal, item, live_posts, filterStatus, sharePostWithBrand, setSelectedSocialPost, selectedSocialPosts }) => {
    const [formData, setFormData] = useState({
        captions: item?.captions?.map(c => ({ name: "captions", value: c })),
        fileList: []
    });
    const [validationErrors, setValidationErrors] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const toaster = useToaster();
    const fileUploadParams = {
        folder: 'campaign_application',
        campaign_id: item?.campaign?.id,
    }


    const getStatusColor = (status) => {
        if (status === 'Reject')
            return 'reject';
        if (status === 'Cancelled')
            return 'cancel';
        if (status === 'Accept')
            return 'accept';
        if (status === 'Link posted')
            return 'link';
        if (status === 'Approved')
            return 'approve';
        if (status === 'Pending')
            return 'pending';

    }

    const getStatusName = (status) => {
        if (status === 'Reject')
            return 'Rejected';
        if (status === 'Cancelled')
            return 'Cancelled';
        if (status === 'Accept')
            return 'Accepted';
        if (status === 'Link posted')
            return 'Link posted';
        if (status === 'Approved')
            return 'Approved';
        if (status === 'Pending')
            return 'Pending';
    }

    const itemSelectedPostColor = (platform) => {
        if (platform === "FACEBOOK") {
            return (
                'bg-[#788cb5]'
            )
        } else if (platform === "INSTAGRAM") {
            return (
                'bg-[#F56040]'
            )
        } else if (platform === "TIKTOK") {
            return (
                'bg-[#afafaf]'
            )
        }
    }


    const checkItemIsSelected = (sp, platform) => {
        if (selectedSocialPosts[sp] !== undefined) {
            return (
                <div className={`card ${itemSelectedPostColor(platform)} `}>
                    <img src={selectedSocialPosts[sp]?.photo} alt="" />
                    <div className="post-desc text-white">
                        <div className="title">{selectedSocialPosts[sp]?.text}</div>
                        <div className="caption">{selectedSocialPosts[sp]?.post_link}</div>
                        <div className="desc">{selectedSocialPosts[sp]?.created_time}</div>
                    </div>
                </div>

            )
        } else {
            return (
                <div className="card">
                    Please Select a post for review
                </div>

            )
        }
    }

    // ReApply for campaign
    const handleSubmitForm = (e) => {
        e.preventDefault()
        let config = {
            url: ApiUrl.updateCampaign,
            method: 'POST',
            body: {
                ...formData,
                campaign_id: item?.campaign?.id,
                campaign_request_id: item?.id,
            }
        }
        if (formData?.fileList?.length <= 0 || formData?.captions?.length <= 0) {
            toaster.push(<Notification type='warning' header="Warning"  >Please provide files & captions </Notification>, {
                placement: 'topEnd'
            });
            return false;
        }
        setIsLoading(true);

        APIRequest(
            config,
            res => {
                setIsLoading(false);
                toaster.push(<Notification type='success' header="Success"  >{res.message}</Notification>, {
                    placement: 'topEnd'
                });
                // navigate('/my-posts')
                setShowModal(false);
            },
            err => {
                setIsLoading(false);
                if (err.response.status === 422)
                    setValidationErrors(err.response.data.errors);

            }
        )
    }



    const handleOnChange = (value, index) => {
        let caption = formData?.captions.find((f, i) => (i === index));
        const updatedCaption = { ...caption, value }
        const allCaptions = formData?.captions.map((c, i) => i === index ? updatedCaption : c);
        const updatedFormData = {
            ...formData,
            captions: allCaptions
        };
        setFormData(updatedFormData);
    }

    const addMore = () => {
        let updatedCaptions = [...formData?.captions, { name: 'Caption', value: '' }];
        setFormData({ ...formData, captions: updatedCaptions })
    }

    const removeCaption = (index) => {
        let updatedCaptions = formData?.captions.filter((f, i) => (i !== index))
        setFormData({ ...formData, captions: updatedCaptions })
    }

    const onUploadSuccess = (response, file) => {
        const fileData = {
            id: file?.fileKey,
            file: response.file,
            raw: file,
        }
        const updatedfileList = [...formData?.fileList, fileData];
        setFormData({
            ...formData,
            fileList: updatedfileList
        })

    }

    const onRemoveFile = (file) => {

        const updatedfileList = formData?.fileList?.filter(f => f.id !== file?.fileKey);
        setFormData({
            ...formData,
            fileList: updatedfileList
        })
    }



    const showCardImd2 = (item) => {

        const vidArr = ["mp4", "mp4", "mov", "wmv", "avi", "avchd", "flv", "f4v", "swf", "mkv", "webm", "html5"];
        const imgArr = ["jpg", "jpeg", "jfif", "pjpeg", "pjp", "png", "svg", "webp", "avif", "gif", "apng"];


        let ext = item?.split('.').pop();

        let fext = ext.toLowerCase();

        const im = imgArr?.find((v) => v === fext);
        const vid = vidArr?.find((vi) => vi === fext);

        if (vid !== undefined) {

            return (
                <video controls className='w-[220px] inline-block p-2 cursor-pointer hover:scale-105 ease-in-out duration-300'
                    src={item} alt="video not found" />
            )
        } if (im !== undefined) {
            return (
                <img
                    className='w-[220px] sm:h-[120px]  inline-block p-2 cursor-pointer hover:scale-105 ease-in-out duration-300'
                    src={item}
                    alt='/'
                />
            )
        }
        else {
            return (
                <img className=" rounded-lg min-w-[150px] h-[100px] " src={item} alt="img not found" />
            )
        }


    }


    const slideLeft = () => {
        var slider = document.getElementById('slider');
        slider.scrollLeft = slider.scrollLeft - 500;
    };

    const slideRight = () => {
        var slider = document.getElementById('slider');
        slider.scrollLeft = slider.scrollLeft + 500;
    };



    const handleSelectedPostColor = (one, two, platform) => {

        if (one === two) {
            if (platform === "FACEBOOK") {
                return (
                    'fbSelectPost'
                )
            } else if (platform === "INSTAGRAM") {

                return (
                    'instaSelectPost'
                )


            } else if (platform === "TIKTOK") {
                return (
                    'tiktokSelectPost'
                )
            }

        } else {

        }
    }
    const handleSelectedPostCheckMark = (one, two) => {

        return one === two;
    }


    const socialMediaIcons = (val) => {

        if (val === "FACEBOOK") {
            const data = {

                "icon": <FaFacebook color='white' size={20} />,
                "bg": "bg-[#4267B2]"
            }

            return data;

        } else if (val === "INSTAGRAM") {

            const data = {
                "icon": <FaInstagramSquare color='white' size={25} />,
                "bg": "instaColor"
            }

            return data;

        } else if (val === "TIKTOK") {
            const data = {
                "icon": <FaTiktok color='white' size={20} />,
                "bg": "bg-black"
            }

            return data;
        }
    }




    return (
        <>
            {(showModal && item !== undefined) ? (
                <>

                    <div className="justify-center  items-center flex flex-col fixed  inset-0 z-50 outline-none focus:outline-none">

                        <motion.div initial={{ opacity: 0, scale: 0.75, y: -200 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0, y: 200 }} transition={{ ease: "easeOut", duration: 0.3 }}
                            className="max-w-[95%] pr-2 rounded-lg bg-white relative mt-7">


                            <div className="absolute right-[6px] top-[-35px]">
                                <img alt="cancel_image" onClick={() => setShowModal(false)} src={cancel} className="transition ease-in-out  hover:scale-110  duration-300 cursor-pointer "></img></div>

                            <div className="sbar overflow-x-hidden max-h-[88vh] overflow-y-auto 

                                  bg-white rounded-lg "  >

                                <div className='flex  '>
                                    <div className="mb-5 md:flex-row flex-col rounded-lg flex w-full md:px-0 px-5" style={{ "boxShadow": "rgb(210 206 206 / 82%) 3px 5px 20px 1px" }}>

                                        <div className="">
                                            <div className=" flex items-center justify-center  ">
                                                <CustomSlider data={item?.files} />
                                            </div>
                                        </div>

                                        <div className="flex md:flex-row flex-col  justify-between w-full my-2 md:mx-3 " >

                                            <div className="md:max-w-[75%] ">

                                                <h5 className="text-[#178ACB] text-lg font-museobb  ">{item?.campaign?.campaign_title}</h5>
                                                <div className>
                                                    <p className="text-gray-600 font-museo ">{item?.campaign?.description}</p>
                                                    <span className="text-gray-600 font-museob  ">Live Date: {item?.campaign?.live_date} </span><br></br>
                                                    <span className="text-gray-600 museob  ">Duration:Duration: {item?.campaign?.duration_start_date} ~ {item?.campaign?.duration_end_date}</span>
                                                    <br />
                                                    <span className="text-gray-600 font-museob  space-x-1 ">
                                                        Files : {item?.files?.map((file, i) => (
                                                            <a key={'ad' + i} href={file} target="_blank" rel="noreferrer" >File-{(i + 1)}</a>
                                                        ))}
                                                    </span>
                                                    {item?.status === 'Reject' && (
                                                        <>
                                                            <br />
                                                            <span className="text-red-600 font-museobb word-break  ">
                                                                {item?.reject_reason}  because
                                                            </span>
                                                            <br />

                                                            <div className=" md:pr-0 pr-5" >
                                                                <span className="text-gray-600 font-museob ">
                                                                    {` " ${item?.reject_reason_description} "`}
                                                                </span>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                            <div className=" flex flex-col justify-between mt-2 md:mt-0 ">
                                                <div>
                                                    <h5>Captions</h5>
                                                    <div className="flex flex-wrap flex-row gap-2 my-1 ">
                                                        {item?.captions?.map((caption, it) => (
                                                            <span key={it} className="bg-[#66BE9C] px-3 py-1  text-white  text-[11px] font-museo  text-center rounded-full ">@{caption}</span>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div>
                                                    <div className=' my-1 '  >
                                                        <span className={`items-center grid   text-white font-museobb ${getStatusColor(item?.status)} text-center tracking-widest rounded-full lg:w-[220px] w-[160px] h-[40px] lg:h-[55px] `} >{getStatusName(item?.status)}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* </div> */}
                                            {/* </div> */}
                                        </div>
                                    </div>
                                </div>

                                <div className='flex my-2 mx-5 flex-col md:px-2 md:items-center '>
                                    <h5 className='flex justify-center my-2 md:my-0 pb-2 '> Campaign task timeline</h5>
                                    <ol className="relative border-l">
                                        {item?.task_timeline?.map((history, i) => (
                                            <li key={`history-${history?.id}`} className="mb-10 ml-6">
                                                <span className="flex absolute -left-3 justify-center items-center w-6 h-6 bg-blue-200 rounded-full ring-8 ring-white ">
                                                    <svg aria-hidden="true" className="w-3 h-3 text-blue-600 " fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd"></path></svg>
                                                </span>
                                                <h3 className="flex items-center mb-1 text-lg font-semibold text-gray-900 ">{history?.task} {i <= 0 && <span className="bg-blue-100 text-blue-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded  ml-3">Latest</span>}</h3>
                                                <time className="block mb-2 text-sm font-normal leading-none text-gray-400">{history?.formatted_creation_date}</time>
                                                <p className="mb-4 text-base font-normal text-gray-500 ">{history?.description}</p>
                                                {history?.status === "Pending" && (
                                                    <div className='flex flex-col  '>
                                                        <div className='relative flex items-center  w-full '>
                                                            <MdChevronLeft className='opacity-50 cursor-pointer hover:opacity-100' onClick={slideLeft} size={40} />
                                                            <div
                                                                id='slider'
                                                                className=' sbar w-full h-full overflow-x-scroll scroll whitespace-nowrap scroll-smooth '
                                                            >
                                                                {history?.files?.map((file, it) => (
                                                                    <a key={it} rel="noreferrer" href={file} target="_blank" >{showCardImd2(file)}</a>
                                                                ))}
                                                            </div>
                                                            <MdChevronRight className='opacity-50 cursor-pointer hover:opacity-100' onClick={slideRight} size={40} />
                                                        </div>


                                                        <p className="inline-flex flex-wrap gap-y-2 items-center py-2 px-4 text-black font-medium" >
                                                            Caption:
                                                            {history?.captions?.map((caption, i) => (
                                                                <span key={i} className='bg-blue-100 text-blue-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded ml-3'> {caption}</span>
                                                            ))}
                                                        </p>
                                                    </div>
                                                )}
                                                <p className={`inline-flex items-center py-2 px-4 text-white font-medium ${getStatusColor(history?.status)} rounded-lg border `}>{getStatusName(history?.status)}</p>
                                            </li>

                                        ))}

                                    </ol>

                                </div>

                                {item?.status === 'Accept' && (

                                    <div className="social-post-wrapper gap-x-3">
                                        {live_posts?.map(sp => (
                                            <div key={`sp-${sp?.id}`} className="social-post-list">

                                                <div className={`p-2 font-museobb ${socialMediaIcons(sp?.platform)?.bg} gap-x-2 items-center  text-white flex`}>

                                                    {socialMediaIcons(sp?.platform)?.icon}
                                                    {sp?.platform}

                                                </div>

                                                <div className="select-box break-all  ">
                                                    <>
                                                        {checkItemIsSelected(sp?.id, sp?.platform)}

                                                    </>

                                                </div>
                                                <div className={`post-list-inner sbar ${socialMediaIcons(sp?.platform)?.bg} `}>
                                                    {sp?.data?.map(post => (
                                                        <div key={`list-${sp?.id}-post-${post?.post_id}`} onClick={() => setSelectedSocialPost(sp?.id, post)} className={` ${handleSelectedPostColor(selectedSocialPosts[sp.id]?.post_id, post?.post_id, sp?.platform)}  card bg-white `}>

                                                            <img src={post?.photo} alt="post_img" className="imgg break-all " />
                                                            <div className="post-desc relative ">
                                                                <div className="title">{post?.text}</div>
                                                                <div className="caption">{post?.post_link}</div>
                                                                <div className="desc">{post?.created_time}</div>

                                                            </div>

                                                            {handleSelectedPostCheckMark(selectedSocialPosts[sp?.id]?.post_id, post?.post_id) ?
                                                                <img src={checkmark_blacktick} alt="check_img" className="w-6 absolute right-5"></img>
                                                                : null}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}

                                      

                                    </div>

                                )}

                                {item?.status === 'Reject' && (
                                    <div className="container mx-auto mt-10 sm:mt-0  font-museo ">
                                        <div className="md:grid  md:gap-6">
                                            {!isLoading && (
                                                <div className="mt-5  md:mt-0  ">
                                                    <div className="overflow-hidden shadow sm:rounded-lg   ">
                                                        <div className="bg-white px-4 py-5 sm:p-6 ">
                                                            <div className="grid md:grid-cols-6 md:grid-rows-1 grid-cols-1 grid-rows-2 gap-4   md:gap-6">

                                                                <div className="col-span-2 sm:col-span-6 md:col-span-2 font-museob ">
                                                                    <label htmlFor="budget" className="block text-sm font-medium text-gray-700">
                                                                        Your Post
                                                                    </label>
                                                                    <Uploader
                                                                        draggable
                                                                        listType="picture-text"
                                                                        headers={authHeaders}
                                                                        defaultFileList={[]}
                                                                        multiple={false}
                                                                        data={fileUploadParams}
                                                                        method={'POST'}
                                                                        action={ApiUrl.uploadFile}
                                                                        onRemove={(file) => { onRemoveFile(file) }}
                                                                        onSuccess={(response, file) => { onUploadSuccess(response, file) }}
                                                                    >
                                                                        <div style={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                            <span>Click or Drag files to this area to upload</span>
                                                                        </div>
                                                                    </Uploader>
                                                                    {hasError(validationErrors, 'file.0')}
                                                                </div>

                                                                <div className="col-span-2 sm:col-span-6 md:col-span-2">
                                                                    <label htmlFor="budget" className="block text-sm font-museob text-gray-700">
                                                                        Captions
                                                                    </label>
                                                                    {formData?.captions?.map((cp, i) => (
                                                                        <div key={i} className="w-full max-w-sm">
                                                                            <div className="md:flex md:items-center mb-6">
                                                                                <div className="md:w-1/2 font-museob ">
                                                                                    <input
                                                                                        type="text"
                                                                                        required
                                                                                        name="captions[]"
                                                                                        value={cp?.value}
                                                                                        onChange={(e) => handleOnChange(e.target.value, i)}
                                                                                        autoComplete="address-level2"
                                                                                        className=" transition ease-out duration-300 mt-1 block w-full rounded-md border border-gray-300 bg-white py-2 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                                    />
                                                                                </div>
                                                                                {i > 0 && (

                                                                                    <span onClick={() => { removeCaption(i) }} className="inline-flex items-center md:mt-0 mt-2 ml-2 px-4 py-2 bg-red-600 hover:bg-red-700  text-white text-sm font-museob rounded-md cursor-pointer ">
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                                        </svg>

                                                                                        Delete
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                            {hasError(validationErrors, `captions.${i}`)}
                                                                        </div>
                                                                    ))}


                                                                    <div className="w-fit">


                                                                        <span onClick={addMore} className="inline-flex items-center px-4 py-2 bg-indigo-500 hover:bg-indigo-600 text-white text-sm font-medium rounded-md gap-x-1 cursor-pointer ">
                                                                            <img src={plusAdd} className="pr-2" alt="plus_img" ></img>

                                                                            Add
                                                                        </span>

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div onClick={handleSubmitForm} className='ssm:pt-1 sm:pt-0 mb-2 flex md:justify-end justify-center items-center md:mr-10 md:pr-3'  >
                                                            <span className="i  overflow-hidden transform  hover:scale-x-105 hover:scale-y-105 transition duration-300 ease-out
                                                            flex justify-center items-center text-white font-museobb bg-[#40BA47]  text-center rounded-full sm:w-[220px] w-[160px] h-[40px] sm:h-[55px]  cursor-pointer" >Update Post</span>
                                                        </div>

                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                {item?.status === 'Accept' && live_posts?.length>=1&& (

                                    <div onClick={sharePostWithBrand} className='ssm:pt-1 sm:pt-0 mb-2 flex justify-center md:justify-end items-center  md:pr-3  my-2 '  >
                                        <span className=" i btn-anim flex justify-center items-center text-white font-museobb bg-[#40BA47]  text-center rounded-full sm:w-[220px] w-[160px] h-[40px] sm:h-[55px]  cursor-pointer " >Save</span>
                                    </div>
                                )}
                            </div>
                        </motion.div>

                    </div>
                    <div className="opacity-60 fixed inset-0 z-40 bg-black duration-150 ease-in-out transition active:shadow-lg"></div>
                </>
            ) : null}

          
           

        </>


    )


};



export default DetailModal;
